module.exports = __webpack_public_path__ + "pic/67.c81326d2.png";